import Expander from "../../../../src/components/Expander";
import * as React from 'react';
export default {
  Expander,
  React
};